<div class="dialog-content">
  <section>
    <form class="k-form" [formGroup]="workingTimeHistoryForm">
      <div class="k-d-flex">
        <kendo-formfield>
          <span class="prefix-currency font-weight-medium">Montag</span>
          <kendo-numerictextbox
            [spinners]="false"
            (valueChange)="inputValueChanged($event, 'monday')"
            id="monday"
            formControlName="monday"
          >
          </kendo-numerictextbox>
        </kendo-formfield>
      </div>
      <div class="k-d-flex">
        <kendo-formfield>
          <kendo-numerictextbox
            [spinners]="false"
            (valueChange)="inputValueChanged($event, 'tuesday')"
            id="tuesday"
            formControlName="tuesday"
          >
          </kendo-numerictextbox>
        </kendo-formfield>
      </div>
      <div class="k-d-flex">
        <kendo-formfield>
          <kendo-numerictextbox
            [spinners]="false"
            (valueChange)="inputValueChanged($event, 'wednesday')"
            id="wednesday"
            formControlName="wednesday"
          >
          </kendo-numerictextbox>
        </kendo-formfield>
      </div>
      <div class="k-d-flex">
        <kendo-formfield>
          <kendo-numerictextbox
            [spinners]="false"
            (valueChange)="inputValueChanged($event, 'thursday')"
            id="thursday"
            formControlName="thursday"
          >
          </kendo-numerictextbox>
        </kendo-formfield>
      </div>
      <div class="k-d-flex">
        <kendo-formfield>
          <kendo-numerictextbox
            [spinners]="false"
            (valueChange)="inputValueChanged($event, 'friday')"
            id="friday"
            formControlName="friday"
          >
          </kendo-numerictextbox>
        </kendo-formfield>
      </div>
      <div class="k-d-flex">
        <kendo-formfield>
          <kendo-numerictextbox
            [spinners]="false"
            (valueChange)="inputValueChanged($event, 'saturday')"
            id="saturday"
            formControlName="saturday"
          >
          </kendo-numerictextbox>
        </kendo-formfield>
      </div>
      <div class="k-d-flex">
        <kendo-formfield>
          <kendo-numerictextbox
            [spinners]="false"
            (valueChange)="inputValueChanged($event, 'sunday')"
            id="sunday"
            formControlName="sunday"
          >
          </kendo-numerictextbox>
        </kendo-formfield>
      </div>

      <div class="k-d-flex">
        <kendo-formfield>
          <kendo-numerictextbox
            [decimals]="0"
            [format]="'d'"
            [spinners]="false"
            (valueChange)="entryIndexChanged($event)"
            id="entry-index"
            formControlName="entryIndex"
          >
          </kendo-numerictextbox>
        </kendo-formfield>
      </div>
    </form>
  </section>

  <hr class="k-my-6.5" />
</div>

<footer #dialogFooter class="k-d-flex k-justify-content-between">
  <button (click)="close()" kendoButton size="large" themeColor="secondary" class="k-mr-4 !k-pr-4">
    <span class="custom-symbol close k-mr-3"></span>
    <span class="label">Schließen</span>
  </button>

  <button
    kendoButton
    (click)="submit()"
    class="!k-pr-4"
    themeColor="base"
    size="large"
    [disabled]="!updateEnabled"
  >
    <fa-icon class="add k-text-white k-mr-3" [icon]="faPenToSquare"></fa-icon>
    <span class="label">Ändern</span>
  </button>
</footer>
